import { autoinject, bindable, observable } from 'aurelia-framework';
import { IScopeAM } from '../../scopes/scope-service';
import { includes } from 'lodash';
import * as moment from 'moment';
import { sortBy } from 'lodash';

@autoinject
export class ScopeSelector {
	@bindable availableScopes: IScopeAM[];
	@bindable preSelectedScopes: string[];
	@bindable selectionChanged: (selectedItems: any) => void;
	@bindable primaryServiceStructureId: string;
	@bindable requiredServiceStructureId: string | undefined;

	@observable scopeHierarchy: { heading: string, years: { year: string, scopes: IScopeAM[] }[] }[] = [];

	selectedItems: { [id: string]: boolean } = {};

	attached() {
		this.availableScopesChanged();
	}

	primaryServiceStructureIdChanged() {
		this.availableScopesChanged();
	}

	availableScopesChanged() {
		this.selectedItems = {};
		this.scopeHierarchy = [];

		if (!this.availableScopes || !this.primaryServiceStructureId) {
			return;
		}

		var filteredScopes = this.requiredServiceStructureId
			? this.availableScopes.filter(s => s.serviceStructureId === this.requiredServiceStructureId)
			: this.availableScopes;

		if (!filteredScopes) {
			return;
		}


		const primaryServiceStructureId = this.primaryServiceStructureId;
		const requiredServiceStructureId = this.requiredServiceStructureId;
		var scopeHierarchyObject = {};

		filteredScopes.forEach(function (scope) {
			const serviceStructureName = (scope.serviceStructureId === primaryServiceStructureId || scope.serviceStructureId === requiredServiceStructureId)
				? ''
				: scope.serviceStructureName;
			const year = moment(scope.startDate).year();

			scopeHierarchyObject[serviceStructureName] = scopeHierarchyObject[serviceStructureName] || [];
			scopeHierarchyObject[serviceStructureName][year] = scopeHierarchyObject[serviceStructureName][year] || [];
			scopeHierarchyObject[serviceStructureName][year].push(scope);
		});

		const scopeHierarchyUnSorted = Object.keys(scopeHierarchyObject).map(function (serviceStructureName) {
			return {
				heading: serviceStructureName,
				years: Object.keys(scopeHierarchyObject[serviceStructureName]).reverse().map(function (year) {
					return {
						year: year,
						scopes: scopeHierarchyObject[serviceStructureName][year]
					};
				})
			};
		});

		this.scopeHierarchy = sortBy(scopeHierarchyUnSorted, x => x.heading); // primary comes first, as it's heading is empty

		this.availableScopes.forEach(s => this.selectedItems[s.id] = includes(this.preSelectedScopes, s.id));
	}

	requiredServiceStructureIdChanged() {
		this.availableScopesChanged();
	}

	// Used as change delegate in the checkboxes
	selectedScopesChanged() {
		if (!this.selectionChanged) {
			return;
		}

		const selectedItems = Object.keys(this.selectedItems).filter(key => this.selectedItems[key] === true);
		this.selectionChanged({ selectedItems });
	}
}
